export const ru = {
    aviaFilter_baggage: 'С багажом',
    departureAtThereTimes_Evening: 'Вечер',
    departureAtThereTimes_Morning: 'Утро',
    hotelFilter_confirmationTypes_Instant: 'Моментальная бронь',
};
